import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail } from "lucide-react";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-ink py-16 text-cream">
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <div className="flex flex-col gap-12 md:flex-row md:items-start md:justify-between">
        <div className="max-w-sm">
          <div className="flex items-center gap-3">
            <img
              src="/images/logo-books.png"
              alt="Purple Space Library logo"
              className="h-10 w-10 rounded-xl object-cover ring-1 ring-cream/20"
            />
            <span className="font-serif text-xl tracking-tight">
              Purple Space <span className="italic text-terracotta">Library</span>
            </span>
          </div>
          <p className="mt-5 text-sm leading-relaxed text-cream/70">
            A children's library and hands-on learning hub in Udupi, Karnataka.
            Room to wonder, space to grow — since 2018.
          </p>
        </div>

        <nav className="grid grid-cols-2 gap-x-16 gap-y-3 text-sm" aria-label="Footer">
          {[
            ["Collection", "/#collection", "collection"],
            ["Manifesto", "/#manifesto", "manifesto"],
            ["Activities", "/#activities", "activities"],
            ["Events", "/#events", "events"],
            ["Membership", "/#membership", "membership"],
            ["Plan a Visit", "/#visit", "visit"],
          ].map(([label, href, id]) => (
            <a
              key={id}
              href={href}
              data-testid={`footer-link-${id}`}
              className="text-cream/70 transition-colors duration-200 hover:text-terracotta"
            >
              {label}
            </a>
          ))}
          <Link
            to="/journal"
            data-testid="footer-link-journal"
            className="text-cream/70 transition-colors duration-200 hover:text-terracotta"
          >
            Journal
          </Link>
          <Link
            to="/admin"
            data-testid="footer-link-admin"
            className="text-cream/70 transition-colors duration-200 hover:text-terracotta"
          >
            Library Desk
          </Link>
        </nav>

        <div className="flex gap-3">
          {[
            [Instagram, "instagram"],
            [Facebook, "facebook"],
            [Mail, "email"],
          ].map(([Icon, id]) => (
            <a
              key={id}
              href="#top"
              aria-label={id}
              data-testid={`footer-social-${id}`}
              className="flex h-10 w-10 items-center justify-center rounded-full border border-cream/20 text-cream/80 transition-colors duration-200 hover:border-terracotta hover:text-terracotta"
            >
              <Icon size={17} />
            </a>
          ))}
        </div>
      </div>

      <div className="mt-14 flex flex-col gap-3 border-t border-cream/10 pt-8 text-xs text-cream/50 md:flex-row md:items-center md:justify-between">
        <p data-testid="footer-copyright">© 2026 Purple Space Library · Perampalli, Udupi, Karnataka</p>
        <p className="font-serif text-sm italic text-cream/60">
          "A room without books is like a body without a soul."
        </p>
      </div>
    </div>
  </footer>
);
